// services/salesService.js
import axios from "axios";
import config from "../config/config";
import { handleError } from "../utils/errorHandler";
import { format } from "date-fns";

const BASE_URL = `${config.apiUrl}/api/sales`;

export const salesService = {
  getDailySales: async (
    startDate = new Date(),
    endDate = new Date(),
  //  closingTime = 4,
    validPaymentsOnly = false,
    isArqueoOnly = false
  ) => {
    try {
      // Construir parámetros de consulta
      const params = {
        startDate: format(startDate, "yyyy-MM-dd'T'HH:mm:ss"),
        endDate: format(endDate, "yyyy-MM-dd'T'HH:mm:ss"),
     //   closingTime: closingTime,
      };

      // Añadir parámetros opcionales
      if (validPaymentsOnly) {
        params.validPaymentsOnly = "false";
      }

      if (isArqueoOnly) {
        params.isArqueoOnly = "true";
      }

      // Hacer la solicitud con todos los parámetros
      const response = await axios.get(`${BASE_URL}/dailySales`, { params });
      console.log("service.dailySales ", response)
      return response.data;
    } catch (error) {
      console.error("Error en getDailySales:", error);
      throw handleError(error);
    }
  },

  getMetrics: async (
    startDate = new Date(),
    endDate = new Date(),
  //  closingTime = 4,
    validPaymentsOnly = false,
    isArqueoOnly = false
  ) => {
    try {
      const sales = await salesService.getDailySales(
        startDate,
        endDate,
      //  closingTime,
        validPaymentsOnly,
        isArqueoOnly
      );
      console.log("service.getMetrics ", sales)
      return sales.data.salesByDate.summary;
    } catch (error) {
      console.error("Error en getMetrics:", error);
      throw handleError(error);
    }
  },
};

export default salesService;
